import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as game from '../../controllers';
import errorCatcher from '../../utils/errorCatcher';

import BottomNavigation from '../DashboardViews/bottomNavigation';
import RestartButton from '../components/restartButton';
import firstOfRanking from '../../images/final-first-of-ranking.png';
import firstOfLocalRanking from '../../images/final-first-of-local-ranking.png';
import notFirstOfRanking from '../../images/final-not-first-of-ranking.png';

class FinishedGame extends Component {
    constructor (props) {
        super(props);
        this.state = {
            image: notFirstOfRanking
        };
    }

    componentDidMount () {
        game.ranking.getRankingById(this.props.user._id).then(response => {
            if (response.positionGlobal === 1) {
                this.setState({ image: firstOfRanking });
            };
            if (response.positionSchool === 1) {
                this.setState({ image: firstOfLocalRanking });
            }
        }).catch((err) => errorCatcher(err));
    }

    render () {
        return (
            <div className='finishedGame'>
                <img src={this.state.image} />
                <RestartButton />
                <BottomNavigation />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user.user
});

export default connect(mapStateToProps)(FinishedGame);



// WEBPACK FOOTER //
// ./src/views/UserViews/finishedGameView.js